<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('rentalDetails.breadcrumb_1')}}</router-link></li>
            <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3 almarai-bold" aria-current="page">{{$t('rentalDetails.breadcrumb_2')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <div class="text-center" v-if="isLoading">
      <mainloader />
    </div>

    <div v-else class="row">
      <div class="col">
        <div class="row pt-3 justify-content-center" v-if="!isLoading">
          <div class="col text-center algin-content-center">
            <swiper :modules="modules" :pagination="{ clickable: true }" :spaceBetween="10"
              :thumbs="{ swiper: thumbsSwiper }" :navigation="true" :autoplay="{ delay: 2500, disableOnInteraction: false,}"
              :style="{'--swiper-navigation-color': '#fff','--swiper-pagination-color': '#fff',}" class="br-radius"
            >
              <swiper-slide style="position:relative" v-for="(gllary, index) in row.mediaFiles" :key="index">
                <span class="favorite" v-if="value.property.Favorites && value.property.Favorites.length" @click.prevent="removeFavorite(value.property.id, 'value.property.mediaFiles', index)">
                  <i class="fa-solid fa-heart favorite-icon-remove"></i>
                </span>
                <span  class="favorite" v-else @click.prevent="addFavorite(value.property.id, 'value.property.mediaFiles', index)">
                  <i class="fa-solid fa-heart favorite-icon"></i>
                </span>
                <img :src="MEDIA_URL+gllary.filePath" alt="Slide Image" class="w-100 max-h" />
              </swiper-slide>
            </swiper>

            <swiper @swiper="setThumbsSwiper" :spaceBetween="10" :slidesPerView="4" 
              :freeMode="true"
              :watchSlidesProgress="true"
              :modules="modules"
              class="pt-3 mouse-hand"
            >
              <swiper-slide v-for="(image,indx) in row.mediaFiles" :key="indx">
                <img :src="MEDIA_URL+image.thumbnail" class="img-fluid br-radius" alt="">
              </swiper-slide>
            </swiper>
          </div>
        </div>

        <div class="row pt-3" >
          <div class="col">
            <div class="row pt-3" >
              <div v-if="value.property" class="col-12 col-md-8 button-center">
                <div class="fonttext-14 almarai-regular">{{value.property.title}}</div>
                <div class="gray-color d-flex fonttext-14 pt-1">
                  <i class="fa-solid fa-location-dot pt-1"></i>
                  <div class="mx-1">{{value.property.Neighborhood.name}}</div>
                  <div>{{value.property.City.name}}</div>
                </div>
              </div>
            </div>
            <hr class="line-color">

            <div class="row pt-3">
              <div class="col-auto ps-0">
                <img src="/assets/images/icons/Frame-8.png" class="width-48" alt="">
              </div>
              <div class="col" v-if="value.statusChoices">
                <h6 class="almarai-regular mb-0 fonttext-14 gray-color">{{$t('rentalDetails.title_1')}}</h6>
                <div class="text-style-green">{{value.statusChoices[value.property.status]}}</div>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col">
                <!-- <div class="row pt-3" v-if="Agent">
                  <div class="almarai-bold py-2">{{$t('propertydetails.title_9')}}</div>
                  <div class="col-3 col-md-auto" v-if="Agent.avatar">
                    <div class="agent-logo">
                      <img :src="MEDIA_URL+Agent.avatar" class="w-100" alt="">
                    </div>
                  </div>
                  <div v-else class="col-3 col-md-auto">
                    <div class="agent-logo">
                      <img src="/assets/images/icons/image.png" class="w-100" alt="">
                    </div>
                  </div>
                  <div class="col-4 col-md-auto content-end">
                    <div class="almarai-regular">
                      <span>{{Agent.name}}</span>
                      <img src="/assets/images/verify-1.png" class="w-24 mx-2" alt="">
                    </div>
                    <span class="almarai-regular agent-color">{{$t('propertydetails.title_10')}}</span>
                  </div>
                  <div class="col content-end text-start">
                    <span class="mx-2">
                      <a :href="'https://wa.me/+966'+Agent.mobile.substring(1)">
                        <img src="/assets/images/Frame-whatsapp.png" class="img-fluid" alt="">
                      </a>
                    </span>
                    <span class="mx-2">
                      <a :href="'tel:'+Agent.mobile">
                        <img src="/assets/images/Frame-call.png" class="img-fluid" alt="">
                      </a>
                    </span>
                  </div>
                </div> -->

                <div class="row">
                  <div class="almarai-bold py-2">{{$t('rentalDetails.PropertyManager')}}</div>
                  <div class="col-3 col-md-auto">
                    <div class="agent-logo">
                      <img src="/assets/images/icons/image.png" class="w-100" alt="">
                    </div>
                  </div>
                  <div class="col-4 col-md-auto content-end space">
                    <div class="almarai-regular pb-2">
                      <!-- <img src="/assets/images/verify-1.png" class="w-24 mx-2" alt=""> -->
                      {{$t('rentalDetails.Ahmed_AlMuhaisni_Company')}}
                    </div>
                    <span class="almarai-regular agent-color">{{$t('rentalDetails.PropertyManager')}}</span>
                  </div>
                </div>

                <!-- begin:ownerData -->
                <!-- <div v-else class="row pt-3">
                  <div class="almarai-bold py-2">{{$t('propertydetails.ownerName')}}</div>
                  <div class="col-3 col-md-auto" v-if="adCreator.avatar">
                    <div class="agent-logo">
                      <img :src="MEDIA_URL+adCreator.avatar" class="w-100" alt="">
                    </div>
                  </div>
                  <div v-else class="col-3 col-md-auto">
                    <div class="agent-logo">
                      <img src="/assets/images/icons/image.png" class="w-100" alt="">
                    </div>
                  </div>
                  <div class="col-4 col-md-auto content-end">
                    <div class="almarai-regular">
                      <span>{{adCreator.name}}</span>
                      <img src="/assets/images/verify-1.png" class="w-24 mx-2" alt="">
                    </div>
                    <span class="almarai-regular agent-color">{{$t('propertydetails.ownerName')}}</span>
                  </div>
                  <div class="col text-start content-end">
                    <span class="mx-2">
                      <a :href="'https://wa.me/+966'+adCreator.mobile.substring(1)">
                        <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                      </a>
                    </span>
                    <span class="mx-2">
                      <a :href="'tel:'+adCreator.mobile">
                        <img src="/assets/images/icons/phoneNumber.png" class="width-48" alt="">
                      </a>
                    </span>
                  </div>
                </div> -->
                <!-- end:ownerData -->
              </div>
            </div>
          </div>
        </div>
        <h6 class="almarai-bold pt-3">{{$t('rentalDetails.title_2')}}</h6>
        <div class="row pt-3 justify-content-between" v-if="value.property">
          <div class="col">
            <div class="row pt-2">
              <div class="col-auto">
                <img src="/assets/images/icons/Frame-8.png" class="width-48" alt="">
              </div>
              <div class="col" v-if="value.property.collectedAmount">
                <span class="text-style">{{$t('rentalDetails.paid')}}</span><br>
                <span class="green-2B almarai-bold">{{value.property.collectedAmount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span></span>
              </div>
            </div>
          </div>
          <div class="col" v-if="value.property.remainingPayments">
            <div class="row">
              <div class="col-auto">
                <img src="/assets/images/icons/Frame-5.png" class="width-48" alt="">
              </div>
              <div class="col-auto">
                <span class="text-style">{{$t('rentalDetails.title_4')}}</span><br>
                <span class="gray-color-60 almarai-bold">{{value.property.remainingPayments}} <span class="mx-1 icon-saudi_riyal_bold_new"></span></span>
              </div>
            </div>
          </div>
        </div>

        <div class="row py-4" v-if="value.property">
          <div class="col" v-if="value.property.rentalTerm">
            <div class="row">
              <div class="col-auto">
                <img src="/assets/images/icons/Frame-calendar-2.png" class="width-48" alt="">
              </div>
              <div class="col-auto">
                <span class="text-style">{{$t('rentalDetails.title_5')}}</span><br>
                <span class="orange-color almarai-bold">{{value.property.rentalTerm}} {{value.rentalUnits[value.property.rentalUnit]}} </span>
              </div>
            </div>
          </div>
          <div class="col" v-if="rows.length">
            <div class="row">
              <div class="col-auto">
                <img src="/assets/images/icons/Frame-calendar.png" class="width-48" alt="">
              </div>
              <div class="col" v-for="(row, index) in rows" :key="index">
                <span class="text-style">{{$t('rentalDetails.title_6')}}</span><br>
                <span  class="gray-color-60 almarai-bold">{{moment(row.dueDate).format('DD / MM /YYYY')}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="value.property">
          <div class="col" v-if="value.property.totalDueAmount">
            <div class="row pt-2">
              <div class="col-auto">
                <img src="/assets/images/icons/Frame-7.png" class="width-48" alt="">
              </div>
              <div class="col-auto">
                <span class="text-style">{{$t('rentalDetails.title_7')}}</span><br>
                <span class="brown-color almarai-bold">{{value.property.totalDueAmount}} <span class="mx-1 brown-color icon-saudi_riyal_bold_new"></span></span>
              </div>
            </div>
          </div>
          <div class="col" v-if="value.property.rentExpire" >
            <div class="row">
              <div class="col-auto">
              <img src="/assets/images/icons/Frame-6.png" class="width-48" alt="">
            </div>
            <div class="col-auto">
              <span class="text-style">{{$t('rentalDetails.title_8')}}</span><br>
              <span class="almarai-bold">{{moment(value.property.rentExpire).format('DD / MM /YYYY')}}</span>
            </div>
            </div>
          </div>
        </div>

        <!--begin:location-->
        <div class="row pt-3" v-if="value.property">
          <div class="col" v-if="value.property.latitude && value.property.longitude">
            <div class="almarai-bold py-2">{{$t('rentalDetails.title_9')}}</div>
            <div ref="myMap" style="width: 100%; height: 350px;"></div>
          </div>
        </div>
        <!--end:location-->

        <div class="row pt-4 justify-content-center">
          <div class="col-6 col-md-6 text-center content-center">
            <a :href="`https://wa.me/+966920016962?text= ${customer_ServiceMessage} ${encodeURIComponent(whatsAppTextPublic)}`" target="_blank">
              <div class="card contactService">
                <div class="card-body">
                  <div class="d-block d-md-none">
                    <img src="/assets/images/icons/call-calling.png" alt="">
                  </div>
                  <span class="d-none d-md-block">
                    <img src="/assets/images/icons/call-calling.png" alt="">
                    <span class="mx-2">{{$t('contactService')}} {{$t('customers')}}</span>
                  </span>
                  <div class="d-block d-md-none">{{$t('contactService')}} {{$t('customers')}}</div>
                </div>
              </div>
            </a>
          </div>
          <div class="col-6 col-md-6">
            <router-link :to="'/lawyerRequested/'+propertyId+'?propertyType=property'">
              <div class="card contactLawyer">
                <div class="card-body">
                  <div class="row justify-content-center">
                    <div class="col-auto d-block d-md-none content-center text-center">
                      <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                    </div>
                    <div class="almarai-bold d-block d-md-none">{{$t('contactLawyer')}}</div>
                    <span class="d-none lawyer-style d-md-block">
                      <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                      <span class="mx-2">{{$t('contactLawyer')}}</span>
                    </span>
                    <!-- <div class="col-auto button-center ps-0">
                      <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                      <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                    </div> -->
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <!-- <div class="col-12 col-md-6 fields">
            <div class="card requestFinance">
              <div class="card-body">
                <div class="row justify-content-center">
                  <div class="col-8 col-md-8 finance_text">
                    <div>{{$t('needFinancing')}}</div>
                    <div>{{$t('manageObligations')}}</div>
                    <div class="row pt-3 finance_text">
                      <div class="col-9 col-md-5 btn_requestFinance">
                        <router-link :to="'/createfinance/'+propertyId">
                        <span class="text_btn">{{$t('ApplyFnancing')}}</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 col-md-4 content-center text-direction">
                    <img src="/assets/images/Vector.png" class="img_requestFinance" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="row pt-4 financeOrder">
          <div class="col-12 fields">
            <div class="card requestFinance">
              <div class="card-body">
                <div class="row justify-content-center">
                  <div class="col-8 col-md-8 finance_text">
                    <div>{{$t('needFinancing')}}</div>
                    <div>{{$t('manageObligations')}}</div>
                    <div class="row pt-3 finance_text">
                      <div class="col-9 col-md-5 btn_requestFinance">
                        <router-link :to="'/createfinance/'+propertyId">
                        <span class="text_btn">{{$t('ApplyFnancing')}}</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 col-md-4 content-center text-direction">
                    <img src="/assets/images/Vector.png" class="img_requestFinance" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-4 justify-content-center">
          <div class="col-11 col-md-4" v-if="availableForPay.length"  data-bs-toggle="modal" data-bs-target="#paymentModal">
            <div class="btn-black" >{{$t('payRent')}}</div>
          </div>
          <div class="col-11 col-md-4 fields"  data-bs-toggle="modal" data-bs-target="#exampleModal">
            <div class="btn-green">{{$t('requestMaintenance')}}</div>
          </div>
        </div>


        <!-- begin:modal-availableForPay -->
        <div class="modal fade d-none" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <!-- <div class="row">
                <div class="col mx-3">
                  <span>قيمة دقعة الايجار</span> <br>
                  <div class="d-flex fonttext-14 pt-1">
                    <span class="almarai-bold" v-for="(rent, R_index) in availableForPay" :key="R_index">{{rent.amount}}</span>
                    <span class="mx-1 almarai-bold">{{$t('currency')}}</span>
                    <span class="mx-1 almarai-bold">فقط لاغير</span>
                  </div>
                </div>
              </div> -->
              <div class="modal-body pt-2">
                <div class="row py-2">
                  <div class="col almarai-bold">
                    {{$t('wallet.payment')}}
                  </div>
                  <div class="col-auto mouse-hand" id="closeModal" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="card mb-3 installment" 
                      v-for="(rent, key) in availableForPay" :key="key"
                    >
                      <label class="form-check-label" :for="`Rent_${rent.id}`" @click="setAvailbalePay(key)">
                        <div :class="(installment_Id == rent.id)? 'card-body installment-selected' : 'card-body'">
                          <div class="row">
                            <div class="col">
                              <input class="form-check-input" @change="payRent" type="radio" v-model="installment_Id" :value="rent.id" name="radioDefault" :id="`Rent_${rent.id}`">
                              <span class="almarai-bold">{{$t('rentalDetails.upcomingPayments')}}</span>
                              <span class="mx-1 almarai-bold">{{rent.amount}}</span>
                              <span class="mx-1 icon-saudi_riyal_bold_new"></span>
                              <!-- <span class="almarai-bold">{{$t('currency')}}</span> -->
                              <div class="gray-color">
                                <span>{{$t('rentalDetails.dueDate')}}</span>
                                <span class="mx-2">{{moment(rent.dueDate).format('DD / MM / YYYY')}}</span>
                              </div>
                            </div>
                            <div class="col-auto button-center">
                              <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                              <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end:modal-availableForPay -->
        

        <!-- begin:popupPayment -->
        <div class="modal" tabindex="-1" id="openPopupPay">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row py-2">
                  <div class="col almarai-bold">
                    {{$t('wallet.payment')}}
                  </div>
                  <div class="col-auto mouse-hand" id="closePopupPay" @click="exitPopup" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
                  </div>
                </div>
                <div class="card border-0">
                  <div class="card-body">
                    <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
                    <div class="row pt-3 justify-content-center">
                      <div class="col-12 position-R">
                        <label for="visa" class=" mouse-hand show">
                          <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                            <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                            <div class="row">
                              <div class="col-auto">
                                <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                              </div>
                              <div class="col p-0">
                                <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                                <div class="bankCard">{{$t('wallet.bankCard')}}</div>
                              </div>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div class="row pt-3 justify-content-center">
                      <div class="col-12 position-R">
                        <label for="radioDefault1" class=" mouse-hand show">
                          <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                            <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                            <div class="row">
                              <div class="col-auto">
                                <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                              </div>
                              <div class="col p-0">
                                <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                                <div class="bankCard">{{$t('wallet.appWallet')}}</div>
                              </div>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div class="row pt-5">
                      <div class="text-center" v-if="loadingPay">
                        <loader />
                      </div>
                      <div v-else class="col mouse-hand" @click.prevent="paymentMethod">
                        <div class="btn-green">{{$t('wallet.title_15')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end:popupPayment -->

        <!-- Modal-begin:maintenances -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <!-- <div class="modal-header">
                <button type="button" class="btn-close" id="maintenanceClose" data-bs-dismiss="modal" aria-label="Close"></button>
              </div> -->
              <div class="modal-body">
                <div class="row pt-3">
                  <router-link to="/maintenances/?type=global" @click="exitForm">
                    <div class="col btn-white">
                      <div class="almarai-bold">{{$t('Free_owners_tenants')}}</div>
                      <span class="text-center almarai-regular text-style">{{$t('dedicated_Maintenance')}}</span>
                    </div>
                  </router-link>
                </div>

                <div class="row pt-3">
                  <router-link to="/maintenances/?type=normal" @click="exitForm">
                    <div class="col btn-black">
                      <div class=" almarai-bold">{{$t('requestMaintenance')}}</div>
                      <span class="text-center almarai-regular text-white">{{$t('Within_24hours')}} {{normalOrderPrice}}</span>
                    </div>
                  </router-link>
                </div>

                <div class="row pt-3">
                  <router-link to="/maintenances/?type=fast" @click="exitForm">
                    <div class="col btn-white">
                      <div class=" almarai-bold">{{$t('requestExpress_maintenance')}}</div>
                      <span class="text-center almarai-regular text-style">{{$t('Within_120Minutes')}} {{fastOrderPrice}}</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal-end:maintenances -->

        <!-- Button trigger modal -->
        <button type="button" id="modalSuccess" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#successPayment">
        </button>

        <!-- Modal installment due successfully paid -->
        <div class="modal fade" id="successPayment" tabindex="-1" aria-labelledby="successPaymentLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="btn-close ms-0" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body text-center">
                <div class="row justify-content-center pt-3">
                  <div class="col-12 text-center">
                    <img src="/assets/images/tick-circle.png" alt="">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    {{$t('rentalDetails.installmentDue')}}
                  </div>
                </div>
              </div>
              <div class="row justify-content-center py-3">
                  <div class="col-8 btn-black text-center">
                    <router-link to="/">
                    <div class="text-white">{{$t('rentalDetails.backToHome')}}</div>
                    </router-link>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <section>
      <h5 class="almarai-bold">أوراق العقار</h5>
      <div class="row pt-4">
        <div class="col">
          <div class="row">
            <div class="col-auto ps-0">
              <img src="/assets/images/icons/Frame-4.png" alt="">
            </div>
            <div class="col pe-0">
              <div class="mx-2 text-style">رقم الصك</div>
              <div class="pe-2">45344</div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-auto ps-0">
              <img src="/assets/images/icons/Frame-3.png" alt="">
            </div>
            <div class="col pe-0">
              <div class="text-style mx-2" >صورة الهوية </div>
              <div class="orange-color pe-2 almarai-bold">عرض الصورة</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row py-4">
        <div class="col">
          <div class="row">
            <div class="col-auto ps-0">
              <img src="/assets/images/icons/Frame-2.png" alt="">
            </div>
            <div class="col pe-0">
              <div class="mx-2 text-style">رخصة البناء</div>
              <div class="pe-2 almarai-bold orange-color">عرض الرخصة</div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-auto ps-0">
              <img src="/assets/images/icons/Frame-413.png" alt="">
            </div>
            <div class="col pe-0">
              <div class="text-style mx-2">شهادة الدفاع المدني</div>
              <div class="orange-color pe-2 almarai-bold">عرض الشهادة</div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!--begin:documentPayment_WalletBalance -->
    <button type="button"  id="popup_WalletBalanceBtn" class="d-none" data-bs-toggle="modal" data-bs-target="#walletdocument"></button>
    <div class="modal bg-color-B" tabindex="-1" id="walletdocument">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" id="closeWalletBalance" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('walletPaymentConfirmation')}}</h6>
          <div class="modal-body">
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-start">
                {{ USER_WALLET_BALANCE }}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                {{ currentPayment }}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-start">
                {{ remainingBalance }}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="min_loader" class="text-center">
                <loader />
              </div>
              <div v-else class="col text-center" @click.prevent="payInstallment">
                <div class="btn-black">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:documentPayment_WalletBalance -->

    <!--begin:Charge your wallet -->
      <chargeWallet />
    <!--end:Charge your wallet -->
  </div>
</template>

<script>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import { Pagination, Navigation, FreeMode, Thumbs, Autoplay } from "swiper/modules";
import { mapGetters } from "vuex";
import moment from 'moment';
export default {
  name:"rental",
  components: { Swiper, SwiperSlide },
  computed:{
    ...mapGetters(["GET_USER",'MEDIA_URL','USER_WALLET_BALANCE', 'FRONTEND_URL'])
  },
  setup(){
    const thumbsSwiper = ref(null);
    const setThumbsSwiper = (swiper) => {
      thumbsSwiper.value = swiper;
    };
    return {
      thumbsSwiper,
      setThumbsSwiper,
      modules: [FreeMode, Thumbs, Navigation, Pagination, Autoplay],
    }
  },
  data(){
    return {  
      message: "",
      hasError: false,
      errorNumber: 0,
      propertyId: this.$route.params.key,
      isLoading: false,
      value : {},
      map: null,
      marker: null,
      rows: [],
      availableForPay: [],
      installment_Id: null,
      paymentGate: '',
      userLang: 'ar',
      loadingPay: false,
      form: 'installmentList',
      Agent: {},
      normalOrderPrice: 0,
      fastOrderPrice: 0,
      row: {},
      remainingBalance: null,
      currentPayment: null,
      min_loader: false,
      customer_ServiceMessage: this.$t('customer_ServiceMessage'),
      whatsAppTextPublic: `${this.FRONTEND_URL}/rental/${this.$route.params.key}?propertyType=property&v=1`,
    }
  },
  
  methods: {
    getRetrieve(){
      this.hasError = false;
      this.isLoading = true;
      this.$http.get("/api/properties/rentalRetrieve/"+this.propertyId).then(res => {
        // console.log(res);
        this.value = res.data;
        this.row = this.value.property;
        this.rows = this.value.property.NextPayment;
        this.availableForPay = res.data.availableForPay;
        this.Agent = res.data.property.Agent;
        this.whatsAppTextPublic = `${this.FRONTEND_URL}/rental/${this.$route.params.key}?propertyType=property&v=1
        ${res.data.property.Region?.name} ${res.data.property.City?.name}`;
        if(this.value.property.latitude && this.value.property.longitude){
          this.initialGoogleMap();
        }
        window.scroll(0,0);
        // console.log(this.date);
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        this.message = this.$globalError(err);
        this.hasError = true;
      })
    },

    reservation(){
      if(!this.GET_USER) {
        document.getElementById("formLogin").style.display = "block";
        return false;
      }else {
        this.$router.push( {path : "/propertypreview/"+this.propertyId} );
      }
    },

    closeingFN() {
      document.getElementById("formLogin").style.display = "none";
    },

    poupLogin(){
      document.getElementById("formLogin").style.display = "block";
    },

    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.value.property.latitude) ? parseFloat(this.value.property.latitude) :24.7136, 
          lng: (this.value.property.longitude) ? parseFloat(this.value.property.longitude) : 46.6753, 
        },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.value.property.latitude)? parseFloat(this.value.property.latitude) : 24.7136, 
          lng: (this.value.property.longitude) ? parseFloat(this.value.property.longitude) : 46.6753 
        },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
        // console.log(parseFloat(this.value.property.latitude));
    },

    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    // propertyReservation(){
    //   document.getElementById('modalreservation').style.display = 'block';
    // },
    // closeForm(){
    //   document.getElementById('modalreservation').style.display ='none';
    // },

    addFavorite(id, dataName, index){
      this.hasError = false;
      if(!this.GET_USER){
        document.getElementById('formLogin').style.display = "block";
        return false;
      }
      this.$http.post("/api/favorites/add",{
        propertyId: id,
      }).then(res => {
        // console.log(res);
        if(dataName == 'value.property.mediaFiles'){
          this.value.property.Favorites = [{}];
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    removeFavorite(id, dataName, index){
      this.hasError = false;
      if(!this.GET_USER){
        document.getElementById('formLogin').style.display = "block";
        return false;
      }
      this.$http.delete("/api/favorites/remove/"+id).then(res => {
        // console.log(res);
        if(dataName == 'value.property.mediaFiles'){
          this.value.property.Favorites = [];
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    moment,
    formatDate(){
      if(this.userLang == 'ar'){
        moment.locale(this.formatedDate);
      }else{
        moment.locale(this.fallbackLang);
      }
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime);
    },
    payRent(){
      document.getElementById('closeModal').click();
      document.getElementById('openPopupPay').style.display = 'block';
    },

    payInstallment(){
      this.loadingPay = true;
      this.$http.post('/api/properties/payInstallment',{
        installmentId: this.installment_Id,
        paymentGate: this.paymentGate,
      }).then(res => {
        // console.log(res);
        if(this.paymentGate == 'online' && res.data.paymentUrl ){
          window.location.href= res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            document.getElementById('popup_WalletBalanceBtn').click();
          }
          document.getElementById('modalSuccess').click();
        }
        this.loadingPay = false;
      }).catch(err => {
        // console.log(err);
        this.loadingPay = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    exitForm(){
      const modal = bootstrap.Modal.getInstance(
        document.getElementById('exampleModal')
      );
      modal.hide();
    },
    setAvailbalePay(key){
      this.currentPayment = this.availableForPay[key].amount;
    },

    getDatainitial(){
      this.hasError = false;
      this.$http.get("/api/orders/init").then(res => {
        // console.log(res);
        // this.rows = res.data.issues;
        this.normalOrderPrice = res.data.normalOrderPrice;
        this.fastOrderPrice = res.data.fastOrderPrice;
        window.scroll(0,0);
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      });
    },
    paymentMethod(){
      if(this.paymentGate == 'online'){
        this.payInstallment();
      }else{
        this.showPopup();
      }
    },

    exitPopup(){
      document.getElementById('openPopupPay').style.display = 'none';
    },

    showPopup(){
      document.getElementById('openPopupPay').style.display = 'none';
      if(this.currentPayment > this.USER_WALLET_BALANCE){
        document.getElementById('chargeWallet').style.display = 'block';
      }else{
        this.remainingBalance =  this.USER_WALLET_BALANCE - this.currentPayment;
        document.getElementById('popup_WalletBalanceBtn').click();
      }
    },
  },
  created(){
    this.getRetrieve();
    this.getDatainitial();
    this.userLang = localStorage.getItem('lang') ??  'ar';
  },
}
</script>
